import { connect } from 'react-redux';
import {
  fetchNumberRange,
  setNumberRangeForm,
  saveNumberRange,
  deleteNumberRange,
} from '../../../store/modules/numberrange';

import NumberRange from '../components/NumberRange';

const mapActionCreators = {
  fetchNumberRange,
  setNumberRangeForm,
  saveNumberRange,
  deleteNumberRange,
};

const mapStateToProps = state => ({
  numberRange: state.numberRange.numberRanges[state.numberRange.current],
  numberRanges: state.numberRange.numberRanges,
  fetching: state.numberRange.fetching,
});

export default connect(mapStateToProps, mapActionCreators)(NumberRange);



// WEBPACK FOOTER //
// ./src/routes/NumberRange/containers/NumberRangeContainer.js